import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { connectedAccountsStore } from '../store/store';
import { updateBasicIsConnecting } from '../actions/connectBasic/updateBasicIsConnecting';
import { updateBasicAdvancedChecked } from '../actions/connectBasic/updateBasicAdvancedChecked';
import { updateBasicDisplayName } from '../actions/connectBasic/updateBasicDisplayName';
import { updateBasicEmailAddress } from '../actions/connectBasic/updateBasicEmailAddress';
import { updateBasicPassword } from '../actions/connectBasic/updateBasicPassword';
import { updateBasicUseNewFolder } from '../actions/connectBasic/updateBasicUseNewFolder';
import { toggleConnectBasicWindow } from '../actions/connectBasic/toggleconnectBasicWindow';
import { newSyncRequest } from '../services/newSyncRequest';
import { initConnectedAccountsFull } from '../orchestrators/initConnectedAccountsFull';
import { toggleConnectAdvancedWindow } from '../actions/connectAdvanced/toggleConnectAdvancedWindow';
import { resetConnectAdvancedStore } from '../actions/connectAdvanced/resetConnectAdvancedStore';
import strings from 'owa-strings/owa-options-strings';
import { getErrorConnectBasic } from '../selectors/getErrorConnectBasic';
import IncomingAccountInformation from './IncomingAccountInformation';
var styles = require('./ConnectBasicWindow.scss');
var ConnectBasicWindow = /** @class */ (function (_super) {
    tslib_1.__extends(ConnectBasicWindow, _super);
    function ConnectBasicWindow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onConnect = function () {
            var store = connectedAccountsStore();
            if (store.connectBasicState.advancedChecked) {
                toggleConnectBasicWindow({ connectBasicOpen: false });
                resetConnectAdvancedStore(store.connectBasicState.displayName, store.connectBasicState.emailAddress, store.connectBasicState.password, store.connectBasicState.useNewFolder);
                toggleConnectAdvancedWindow({ connectAdvancedOpen: true });
            }
            else {
                updateBasicIsConnecting(true);
                newSyncRequest({
                    DisplayName: store.connectBasicState.displayName || store.connectBasicState.emailAddress,
                    Name: store.connectBasicState.emailAddress,
                    EmailAddress: store.connectBasicState.emailAddress,
                    TargetRootFolder: store.connectBasicState.useNewFolder
                        ? store.connectBasicState.emailAddress
                        : undefined,
                    IncomingPassword: store.connectBasicState.password,
                }).then(function (response) {
                    updateBasicIsConnecting(false);
                    toggleConnectBasicWindow({ connectBasicOpen: false });
                    if (!response.ErrorMessage) {
                        initConnectedAccountsFull();
                    }
                    else {
                        resetConnectAdvancedStore(store.connectBasicState.displayName, store.connectBasicState.emailAddress, store.connectBasicState.password, store.connectBasicState.useNewFolder);
                        toggleConnectAdvancedWindow({ connectAdvancedOpen: true });
                    }
                });
            }
        };
        _this.onClose = function () {
            toggleConnectBasicWindow({ connectBasicOpen: false });
        };
        _this.onAdvancedSettingsChecked = function (ev, checked) {
            updateBasicAdvancedChecked(checked);
        };
        return _this;
    }
    ConnectBasicWindow.prototype.render = function () {
        var store = connectedAccountsStore();
        return (React.createElement(Dialog, { hidden: !store.dialogWindowState.connectBasicOpen, dialogContentProps: {
                type: DialogType.normal,
                title: strings.options_connected_basic_title,
            }, modalProps: {
                isBlocking: true,
                containerClassName: styles.dialog,
                onDismiss: this.onClose,
            } },
            React.createElement(IncomingAccountInformation, { useNewFolder: store.connectBasicState.useNewFolder, disableEmailAddress: false, renderUserNameContent: false, renderNewFolderContent: true, isBasicAuth: true, onUpdateDisplayName: updateBasicDisplayName, onUpdateEmailAddress: updateBasicEmailAddress, onUpdatePassword: updateBasicPassword, onUpdateUseNewFolder: updateBasicUseNewFolder }),
            React.createElement(Label, { className: styles.advanced }, strings.options_connected_basic_advancedSettingsLabel),
            React.createElement(Checkbox, { className: styles.checkbox, label: strings.options_connected_basic_manualConfigCheckbox, defaultChecked: false, onChange: this.onAdvancedSettingsChecked }),
            React.createElement(DialogFooter, null,
                store.connectBasicState.isConnecting && (React.createElement(Spinner, { size: SpinnerSize.large, className: styles.spinner })),
                React.createElement(PrimaryButton, { onClick: this.onConnect, disabled: getErrorConnectBasic() || store.connectBasicState.isConnecting }, strings.options_connected_okButton),
                React.createElement(DefaultButton, { onClick: this.onClose, disabled: store.connectBasicState.isConnecting }, strings.options_connected_cancelButton))));
    };
    ConnectBasicWindow = tslib_1.__decorate([
        observer
    ], ConnectBasicWindow);
    return ConnectBasicWindow;
}(React.Component));
export default ConnectBasicWindow;
//# sourceMappingURL=ConnectBasicWindow.js.map